import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-pv.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationPvConstants } from "../../../../../application/create-application/modules/pv/create-application-location-pv/create-application-location-pv.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import Polygon from "@arcgis/core/geometry/Polygon";
import { MapTools } from "../../../../../map/shared/map.tools";
import { AlertType } from "../../../../../shared/models/alert";
import { ViewApplicationService } from "../../../view-application.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { BehaviorSubject, take, takeUntil } from "rxjs";
import { ViewApplicationLocationPvConstants } from "./view-application-location-pv.constants";
import { PropertyValuationService } from "../../../../../shared/services/modules/property-valuation.service";
import { ViewApplicationLocationService } from "./view-application-location-pv.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import Query from "@arcgis/core/rest/support/Query";
import { ValuationPropertyTableHeadingEnum, ValuationPropertyTableHeadingLookup } from "./prperty-table-headers";
import RecipientUtils from "src/app/shared/utils/recipient-utils";
import { SharedConstants } from "src/app/shared/constants/shared.constants";
import { EditPropertyDetailsPvConstants } from "src/app/shared/components/edit-property-details-pv/edit-property-details-pv.constants";
import { StepService } from "src/app/step/step.service";
import { ViewBlockPropertiesPvService } from "../view-block-properties-pv/view-block-properties-pv.service";
import { ReportService } from "src/app/shared/components/report-form/report.service";
import { getPropertyFieldCardLink, handleReportDownload as handleReportDownload, setMunicipalFieldCardParameters, setPublicFieldCardParameters } from "../shared/field-card-report-function";
let ViewApplicationLocationPvComponent = class ViewApplicationLocationPvComponent extends ApplicationBaseComponent {
    route;
    routerParamsService;
    recipientListService;
    viewApplicationService;
    aflaModuleStrategyService;
    appController;
    mapService;
    stepService;
    viewBlockPropertiesPvService;
    mapTools;
    requestStatusService;
    propertyValuationService;
    changeDetectorRefs;
    viewApplicationLocationService;
    reportService;
    active;
    propertiesForm;
    propertyDetailsForm;
    properties;
    viewBlockAveragesBtnPlaceholder = ViewApplicationLocationPvConstants.VIEW_BLOCK_AVERAGES_BUTTON_PLACEHOLDER;
    resetBlockLbl = ViewApplicationLocationPvConstants.RESET_BLOCK;
    importdata = ViewApplicationLocationPvConstants.IMPORT_DATA;
    descriptionLabel2 = CreateApplicationLocationPvConstants.DESCRIPTION_LABEL_2;
    selectApplicationTypeError = CreateApplicationLocationPvConstants.WARNING_MESSAGE_NO_APPLICATION_TYPE;
    removeDialogTitle = CreateApplicationLocationPvConstants.REMOVE_DIALOG_TEXT;
    fieldCardLinkLabel = ValuationPropertyTableHeadingEnum.PublicFieldCard;
    fieldCardMunicipalLinkLabel = ValuationPropertyTableHeadingEnum.MunicipalFieldCard;
    //public showImportParameters = false;
    propertyLayer;
    zoningLayer;
    ownerLayer;
    blockLayer;
    blockLayerName = ViewApplicationLocationPvConstants.BLOCK_LAYER_NAME;
    propertyLayerName = ViewApplicationLocationPvConstants.PROPERTY_LAYER_NAME;
    showMap = true;
    showAverages = false;
    blockProperties;
    valuationRunId;
    appType;
    valuationMethod;
    propertyType;
    selectedPropertyLayerName = ViewApplicationLocationPvConstants.SELECTED_PROPERTY_LAYER_NAME;
    salesAreasLayerName = ViewApplicationLocationPvConstants.SALES_AREA_LAYER_NAME;
    newValuationBlockLayerName = ViewApplicationLocationPvConstants.NEW_VALUATION_BLOCK_LAYER_NAME;
    salesAreasPropertyLayerName = ViewApplicationLocationPvConstants.SALES_AREA_PROPERTY_NAME;
    newValuationBlockPropertyLayerName = ViewApplicationLocationPvConstants.NEW_VALUATION_BLOCK_PROPERTY_NAME;
    drawToolLayer = ViewApplicationLocationPvConstants.DRAW_TOOL_LAYER;
    blockConst = ViewApplicationLocationPvConstants.BLOCK_CONSTANT;
    salesAreaConst = ViewApplicationLocationPvConstants.SALES_AREA_CONSTANT;
    actions = {
        loadValuationBlock: ViewApplicationLocationPvConstants.LOAD_VALUATION_BLOCK,
        loadSalesArea: ViewApplicationLocationPvConstants.LOAD_SALES_AREA,
        reshapingValuationBlock: ViewApplicationLocationPvConstants.RESHAPING_VALUATION_BLOCK,
        drawingSalesArea: ViewApplicationLocationPvConstants.DRAWING_SALES_AREA
    };
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    drawingSalesArea = false;
    drawingBlock = true;
    // private drawingSalesArea = false;
    // private drawingBlock = false;
    // private reshaping = false;
    importMarketAnalysisDataSubscription;
    valuationBlockId;
    propertiesEdited = false;
    sketch;
    //private sketchGraphic: Graphic = null;
    selectedSymbol = {
        type: "simple-fill",
        color: [0, 255, 255],
        style: "none",
        outline: {
            color: [0, 255, 255],
            width: 2,
        },
        width: 2,
    };
    defaultSymbol = {
        type: "simple-fill",
        color: [85, 172, 63],
        style: "none",
        outline: {
            color: [85, 172, 63],
            width: 2,
        },
        width: 2,
    };
    saleAreaSymbol = {
        type: "simple-fill",
        color: [76, 136, 228],
        style: "none",
        outline: {
            color: [76, 136, 228],
            width: 2,
        },
        width: 2,
    };
    blockSymbol = {
        type: "simple-fill",
        color: [255, 0, 0],
        style: "none",
        outline: {
            color: [255, 0, 0],
            width: 2,
        },
        width: 2,
    };
    mapComponent;
    isMapLoaded = false;
    selectedPvPt;
    pvApplication;
    method;
    patchPvPropretyObs;
    patchPvPropretiesObs;
    postPvPropretiesObs;
    postPvPropretiesOwnersObs;
    selectedProperty;
    deletePvPropretyObs;
    ownerGroups;
    tableMapper;
    subscription;
    bockAttributes;
    propertyToEdit;
    propertyTypesOptions = [];
    zoningsFromLookups = [];
    zoningFilterString = "1=1";
    createLookupsSubscription;
    getStepMetaObservableSubscription;
    selectedPropertySubscription;
    categoryFilterString;
    categoriesFromLookups = [];
    constructor(route, routerParamsService, recipientListService, viewApplicationService, aflaModuleStrategyService, appController, mapService, stepService, viewBlockPropertiesPvService, mapTools, requestStatusService, propertyValuationService, changeDetectorRefs, viewApplicationLocationService, reportService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.viewApplicationService = viewApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.mapService = mapService;
        this.stepService = stepService;
        this.viewBlockPropertiesPvService = viewBlockPropertiesPvService;
        this.mapTools = mapTools;
        this.requestStatusService = requestStatusService;
        this.propertyValuationService = propertyValuationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.viewApplicationLocationService = viewApplicationLocationService;
        this.reportService = reportService;
    }
    ngOnInit() {
        this.subscribeToProperty();
        this.listenForRouteParamChange();
        this.initialiseForm();
        this.subscribeToBlock();
    }
    ngAfterViewInit() {
        // this.mapService.actionPropertyEnabled = true;
        const chkBlock = document.getElementById(this.blockConst);
        chkBlock.checked = true;
        const chkSalesArea = document.getElementById(this.salesAreaConst);
        chkSalesArea.checked = false;
        this.drawingBlock = true;
        this.drawingSalesArea = false;
    }
    handleRouteChange() {
        this.loadApplication();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
        if (this.zoningLayer) {
            this.zoningLayer.definitionExpression = "1 = 1";
        }
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString,
        };
        this.initializeColumnToObjectMapping();
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.properties = this.aflaModuleStrategyService.form
            .get("propertiesForm")
            .get("properties");
        this.propertyDetailsForm = new FormGroup({
            editIndex: new FormControl(null),
            sgCodeEdit: new FormControl(null),
            portionNumberEdit: new FormControl(null),
            allotmentEdit: new FormControl(null),
            zoningEdit: new FormControl(null),
            descriptionEdit: new FormControl(null),
            addressEdit: new FormControl(null),
            erfNumberEdit: new FormControl(null),
            farmNumberEdit: new FormControl(null),
            unitNumberEdit: new FormControl(0),
            erfSizeEdit: new FormControl(0),
            ownersEdit: new FormControl(null),
        });
        this.propertiesForm.addControl("dataSource", new FormControl(new BehaviorSubject([])));
        this.propertiesForm.addControl("tableSelection", new FormControl(null));
        this.getStepMetaObservableSubscription = this.viewApplicationService
            .getStepMetaObservable(params)
            .subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
            this.loadApplication();
        });
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") &&
            this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    loadApplication() {
        const params = {
            $expand: `properties, properties($expand=owners), salesArea`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe((data) => {
            this.blockProperties = data.value[0].properties;
            this.pvApplication = data.value[0];
            this.showMap = true;
            this.valuationBlockId = data.value[0].id;
            // WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100)
            if (!this.propertiesForm.get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE).value)
                this.propertiesForm
                    .get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE)
                    .setValue(WktConverterUtils.ConvertWktToArcGisJson(this.pvApplication.shape, 102100));
            if (!this.propertiesForm.get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE).value)
                this.propertiesForm
                    .get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE)
                    .setValue(WktConverterUtils.ConvertWktToArcGisJson(this.pvApplication.salesArea.shape, 102100));
            this.changeDetectorRefs.markForCheck();
        });
        this.changeDetectorRefs.markForCheck();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.mapService.actionPropertyEnabled = false;
        this.mapService.actionPropertyOwnerEnabled = false;
        this.mapService.actionBlockEnabled = true;
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.propertyLayer = this.mapService.userMaps.find((a) => a.selectionLayerType.toLowerCase() === "property").layer;
        this.zoningLayer = this.mapService.userMaps.find((a) => a.selectionLayerType.toLowerCase() === "property zone").layer;
        this.ownerLayer = this.mapService.userMaps.find((a) => a.selectionLayerType.toLowerCase() === "property owner")?.layer;
        this.blockLayer = this.mapService.userMaps.find((a) => a.selectionLayerType.toLowerCase() === "block")?.layer;
        this.blockLayer.popupEnabled = true;
        this.mapService.onSelectBlock = () => { };
        this.mapService.addBlock = (b) => this.addBlock(b);
        if (this.aflaModuleStrategyService.lookups.has("propertyTypes") &&
            this.aflaModuleStrategyService.lookups.has("Zoning")) {
            this.propertyTypesOptions =
                this.aflaModuleStrategyService.lookups.get("propertyTypes");
            this.zoningsFromLookups =
                this.aflaModuleStrategyService.lookups.get("Zoning");
            this.updateDefinitionExpression();
        }
        else {
            this.getLookups();
        }
        this.sketch.on("create", (event) => {
            this.sketchCreateAction(event);
        });
        this.sketch.on("update", (event) => {
            this.sketchUpdateAction(event);
        });
        if (!this.propertiesForm.get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).value &&
            !this.propertiesForm.get(ViewApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value) {
            const blockShape1 = this.propertiesForm.get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE).value;
            if (blockShape1) {
                const blockGeom1 = new Polygon(blockShape1);
                // this.queryZoning(blockGeom1, this.actions.loadValuationBlock);
                this.getPropertiesInPropertyLayer(this.actions.loadValuationBlock, null, blockGeom1);
            }
            const blockShape2 = this.propertiesForm.get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE).value;
            if (blockShape2) {
                const blockGeom2 = new Polygon(blockShape2);
                this.getPropertiesInPropertyLayer(this.actions.loadSalesArea, null, blockGeom2);
            }
        }
        else {
            this.syncMapGeometries(this.actions.loadSalesArea);
            this.syncMapGeometries(this.actions.loadValuationBlock);
        }
        this.changeDetectorRefs.detectChanges();
    }
    resetBlockClicked() {
        this.propertiesForm
            .get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE)
            .reset();
        this.propertiesForm.setControl(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE, new FormControl(this.propertiesForm.get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE).value));
        this.removeExistingProperties(this.actions.loadSalesArea);
        this.syncMapGeometries(this.actions.loadSalesArea);
    }
    sketchCreateAction(event) {
        if (event.state === "start") {
            this.mapService.showPopups = false;
        }
        if (event.state === "complete") {
            this.mapService.showPopups = true;
            if (event.graphic.geometry.type === "polygon") {
                // if (this.sketchGraphic !== null) {
                // }
                let action = "";
                if (this.drawingSalesArea)
                    action = this.actions.drawingSalesArea;
                if (this.drawingBlock)
                    action = this.actions.reshapingValuationBlock;
                // this.removeExistingProperties(this.actions.drawingSalesArea);
                const symbolsAndLayers = this.selectSymbolsAndLayers(action);
                this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(event.graphic.geometry)], symbolsAndLayers.layerName, true, false, symbolsAndLayers.symbols);
                this.getPropertiesInPropertyLayer(action, event.graphic);
            }
        }
        else if (event.state === "cancel") {
            this.mapService.showPopups = true;
        }
        else {
            //this.mapTools.sketchGraphicsLayer.removeAll();
        }
    }
    sketchUpdateAction(event) {
        if (event.state === "complete") {
            if (event.graphics[0].geometry.type === "polygon") {
                if (!this.drawingBlock && !this.drawingSalesArea) {
                    this.appController.showMessage(ViewApplicationLocationPvConstants.SKETCH_UPDATE_NOTIFICATION, AlertType.Warning);
                    this.mapTools.sketchGraphicsLayer.remove(event.graphics[0]);
                    return;
                }
                let action = "";
                if (this.drawingSalesArea)
                    action = this.actions.drawingSalesArea;
                if (this.drawingBlock)
                    action = this.actions.reshapingValuationBlock;
                // this.removeExistingProperties(action);
                const symbolsAndLayers = this.selectSymbolsAndLayers(action);
                if (this.bockAttributes) {
                    event.graphics[0].attributes = JSON.parse(JSON.stringify(this.bockAttributes));
                }
                this.sketch.update([event.graphics[0]], {
                    tool: "reshape",
                    enableRotation: true,
                    enableScaling: true,
                    preserveAspectRatio: true,
                    toggleToolOnClick: false,
                });
                this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(event.graphics[0].geometry)], symbolsAndLayers.layerName, false, false, symbolsAndLayers.symbols);
                this.getPropertiesInPropertyLayer(action, event.graphics[0]);
                this.propertiesEdited = true;
            }
        }
    }
    blockSelected(event) {
        if (event.currentTarget.value == this.salesAreaConst) {
            this.drawingSalesArea = true;
            this.drawingBlock = false;
        }
        else if (event.currentTarget.value == this.blockConst) {
            this.drawingSalesArea = false;
            this.drawingBlock = true;
        }
    }
    importParameters(event) {
        if (event.currentTarget.checked) {
            this.propertiesForm
                .get("importParentAttributesParameters")
                .setValue(true);
        }
    }
    subscribeToBlock() {
        this.subscription = this.mapService.$selectedBlock.subscribe((block) => this.addBlock(block));
    }
    addBlock(block) {
        //this.propertiesForm
        if (block == null ||
            block == undefined ||
            (!this.drawingBlock && !this.drawingSalesArea)) {
            this.appController.showMessage(ViewApplicationLocationPvConstants.ADD_BLOCK_SELECT_ACTION, AlertType.Warning);
            return;
        }
        if (this.drawingBlock &&
            block.attributes.JobID != this.pvApplication.jobId) {
            this.appController.showMessage(ViewApplicationLocationPvConstants.ADD_BLOCK_WARNING, AlertType.Warning);
            const chkBlock = document.getElementById(this.blockConst);
            chkBlock.checked = false;
            const chkSalesArea = document.getElementById(this.salesAreaConst);
            chkSalesArea.checked = true;
            this.drawingBlock = false;
            this.drawingSalesArea = true;
            return;
        }
        if (block.geometry.type === "polygon") {
            // this.showImportParameters = true;
            this.removeExistingProperties(this.actions.reshapingValuationBlock);
            const symbolsAndLayers = this.selectSymbolsAndLayers(this.actions.reshapingValuationBlock);
            if (block.attributes) {
                this.bockAttributes = JSON.parse(JSON.stringify(block.attributes));
            }
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(block.geometry)], this.drawToolLayer, true, false, symbolsAndLayers.symbols);
            this.getPropertiesInPropertyLayer(this.actions.reshapingValuationBlock, block);
        }
    }
    selectSymbolsAndLayers(action) {
        let layerName = this.blockLayerName;
        let symbols = this.defaultSymbol;
        let propertyLayerName = this.propertyLayerName;
        this.mapTools.sketchGraphicsLayer.removeAll();
        if (action == this.actions.drawingSalesArea ||
            action == this.actions.loadSalesArea) {
            this.mapComponent.clearGraphics(this.salesAreasLayerName);
            this.mapComponent.clearGraphics(this.salesAreasPropertyLayerName);
            layerName = this.salesAreasLayerName;
            symbols = this.saleAreaSymbol;
            propertyLayerName = this.salesAreasPropertyLayerName;
            if (action == this.actions.drawingSalesArea) {
                this.propertiesEdited = true;
            }
        }
        else if (action == this.actions.reshapingValuationBlock ||
            action == this.actions.loadValuationBlock) {
            this.mapComponent.clearGraphics(this.newValuationBlockLayerName);
            this.mapComponent.clearGraphics(this.newValuationBlockPropertyLayerName);
            layerName = this.newValuationBlockLayerName;
            symbols = this.blockSymbol;
            propertyLayerName = this.newValuationBlockPropertyLayerName;
        }
        return { symbols, layerName, propertyLayerName };
    }
    loadBlock(symbolsAndLayers, blockType) {
        const blockShape = this.propertiesForm.get(blockType).value;
        if (blockShape) {
            const blockGeom = new Polygon(blockShape);
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(blockGeom)], symbolsAndLayers.layerName, true, false, symbolsAndLayers.symbols);
        }
    }
    reshapingBlock(symbolsAndLayers, blockType) {
        const blockShape = this.propertiesForm.get(blockType).value;
        if (blockShape) {
            const blockGeom = new Polygon(blockShape);
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(blockGeom)], this.drawToolLayer, true, false, symbolsAndLayers.symbols);
        }
        this.propertiesEdited = true;
    }
    syncMapGeometries(action) {
        let symbolsAndLayers;
        const geomArray = [];
        let properties = [];
        const propertiesControl = this.propertiesForm.get("dataSource")
            .value;
        if (propertiesControl) {
            properties = propertiesControl.getValue();
        }
        properties.forEach((prop) => {
            const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
            geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
        });
        this.setupPropertyForm(properties);
        if (this.isMapLoaded) {
            if (action == this.actions.loadValuationBlock ||
                action == this.actions.loadSalesArea) {
                if (action == this.actions.loadValuationBlock) {
                    symbolsAndLayers = this.selectSymbolsAndLayers(action);
                    this.loadBlock(symbolsAndLayers, ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE);
                }
                if (action == this.actions.loadSalesArea) {
                    symbolsAndLayers = this.selectSymbolsAndLayers(action);
                    this.loadBlock(symbolsAndLayers, ViewApplicationLocationPvConstants.SALES_AREA_SHAPE);
                }
                this.mapComponent.addGeometriesOnMap(geomArray, this.propertyLayerName, true, false);
            }
            else {
                if (action == this.actions.reshapingValuationBlock) {
                    symbolsAndLayers = this.selectSymbolsAndLayers(action);
                    this.reshapingBlock(symbolsAndLayers, ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE);
                    this.mapComponent.addGeometriesOnMap(geomArray, symbolsAndLayers.propertyLayerName, true, false);
                }
                else if (action == this.actions.drawingSalesArea) {
                    symbolsAndLayers = this.selectSymbolsAndLayers(action);
                    this.loadBlock(symbolsAndLayers, ViewApplicationLocationPvConstants.SALES_AREA_SHAPE);
                    this.mapComponent.addGeometriesOnMap(geomArray, symbolsAndLayers.propertyLayerName, true, false);
                }
            }
        }
    }
    subscribeToProperty() {
        this.selectedProperty = this.mapService.$selectedProperty;
        this.selectedPropertySubscription = this.selectedProperty.subscribe((block) => {
            if (block !== null) {
                this.requestStatusService.showBusySpinner("subscribeToProperty");
                const sgCode = block.attributes.hasOwnProperty("SgCode")
                    ? block.attributes.SgCode
                    : "";
                let found = false;
                this.blockProperties.forEach((item) => {
                    const check = item.sgCode;
                    if (check === sgCode) {
                        found = true;
                        this.appController.showMessage(ViewApplicationLocationPvConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                        this.requestStatusService.removeBusySpinner("subscribeToProperty");
                    }
                });
                if (!found) {
                    //  this.setProperties(property);
                    //  this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("subscribeToProperty");
                }
            }
        });
    }
    onBtnViewBlockAveragesClicked() {
        this.method = this.pvApplication.method;
        this.importMarketAnalysisDataSubscription =
            this.viewApplicationLocationService
                .importMarketAnalysisData(this.valuationBlockId)
                .subscribe({
                next: () => {
                    this.appController.showMessage("Market analysis data imported", AlertType.Success);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("market analysis data", error, CRUDOperation.Get);
                },
            });
        this.showAverages = true;
    }
    tableItemSelected(array) {
        this.propertiesForm.get("tableSelection").setValue(array);
        if (this.propertiesForm.get("tableSelection").value.length > 0) {
            this.showPropertyDetails();
        }
        const geomArray = [];
        array.forEach((sel) => {
            const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(sel.shape, 102100));
            geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
        });
        if (this.mapComponent && this.mapComponent.mapLoaded) {
            this.mapComponent.addGeometriesOnMap(geomArray, this.selectedPropertyLayerName, true, false, this.selectedSymbol);
        }
    }
    getPropertiesInPropertyLayer(action, sketchGraphic, geometry) {
        const sgCodeArray = [];
        const sgCodeZoneLookup = new Map();
        let selectedPropertyDetails = null;
        const propertyQuery = new Query();
        propertyQuery.returnGeometry = true;
        propertyQuery.outFields = ["*"];
        propertyQuery.where = this.categoryFilterString;
        propertyQuery.spatialRelationship = "contains";
        propertyQuery.geometry = !geometry ? sketchGraphic.geometry : geometry;
        this.propertyLayer.queryFeatures(propertyQuery).then((propFeatures) => {
            this.properties.clear();
            if (propFeatures.features.length > 0) {
                propFeatures.features.forEach((feat) => {
                    const sgCode = this.propertyDataAlternateColumnName(feat.attributes, "SgCode", "sgcode");
                    sgCodeArray.push(sgCode);
                });
                selectedPropertyDetails = propFeatures;
                if (this.ownerLayer !== undefined && this.ownerLayer !== null) {
                    const ownerQuery = new Query();
                    ownerQuery.returnGeometry = false;
                    ownerQuery.outFields = ["*"];
                    ownerQuery.where = "SgCode in ('" + sgCodeArray.join("','") + "')";
                    this.ownerLayer.queryFeatures(ownerQuery).then((ownerFeatures) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                        const selectedOwnerDetails = ownerFeatures;
                        this.getZones(sgCodeArray, sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic);
                    }, (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                        this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
                    });
                }
                else {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.getZones(sgCodeArray, sgCodeZoneLookup, selectedPropertyDetails, undefined, action, sketchGraphic);
                }
            }
            else {
                this.requestStatusService.removeBusySpinner("GetPropertyData");
                this.appController.showMessage(`No properties of type ${this.propertyType} found within the polygon drawn`, AlertType.Warning);
            }
        }, (error) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    getZones(sgCodeArray, sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic) {
        // Query the zoning layer to find properties in the polygon with the correct zoning/property type
        const query = new Query();
        query.returnGeometry = false;
        query.where = "SgCode in ('" + sgCodeArray.join("','") + "')";
        query.outFields = ["*"];
        if (sketchGraphic && sketchGraphic.attributes)
            this.getCurrentBlockInBlockLayer(sketchGraphic);
        this.zoningLayer.queryFeatures(query).then((featureSet) => {
            if (featureSet.features.length > 0) {
                featureSet.features.forEach((feat) => {
                    const sgCode = this.propertyDataAlternateColumnName(feat.attributes, "SgCode", "sgcode");
                    const zone = this.propertyDataAlternateColumnName(feat.attributes, "Zoning", "zoning");
                    sgCodeArray.push(sgCode);
                    sgCodeZoneLookup.set(sgCode, zone);
                });
            }
            this.setProperties(sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic);
        }, (error) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.showMessage(error.message, AlertType.Error);
            this.setProperties(sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic);
        });
    }
    getCurrentBlockInBlockLayer(block) {
        const params = {
            $filter: `jobId eq ${block.attributes.JobID}`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe(x => {
            const application = x.value[0];
            this.propertiesForm.get("parentBlockId").setValue(application.id);
        });
    }
    queryOwners(sgCodeArray, sgCodeZoneLookup, selectedPropertyDetails, action, sketchGraphic) {
        const ownerQuery = new Query();
        let selectedOwnerDetails;
        ownerQuery.returnGeometry = false;
        ownerQuery.outFields = ["*"];
        ownerQuery.where = "SgCode in ('" + sgCodeArray.join("','") + "') and ZoningCategory ='" + this.propertyType + "'";
        this.ownerLayer.queryFeatures(ownerQuery).then((ownerFeatures) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            selectedOwnerDetails = ownerFeatures;
            this.setProperties(sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic);
        }, (error) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    setBlocksProperties(propArray, action, sketchGraphic) {
        if (sketchGraphic) {
            if (action == this.actions.drawingSalesArea) {
                this.propertiesForm
                    .get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE)
                    .setValue(sketchGraphic.geometry.toJSON());
            }
            else if (action == this.actions.reshapingValuationBlock) {
                this.propertiesForm
                    .get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE)
                    .setValue(sketchGraphic.geometry.toJSON());
                if (!this.propertiesForm.get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE).value)
                    this.propertiesForm
                        .get(ViewApplicationLocationPvConstants.SALES_AREA_SHAPE)
                        .setValue(sketchGraphic.geometry.toJSON());
            }
        }
        if (action == this.actions.drawingSalesArea ||
            action == this.actions.loadSalesArea) {
            this.propertiesForm.setControl(ViewApplicationLocationPvConstants.SALES_AREA_PROPERTIES, new FormControl(propArray));
        }
        if (action == this.actions.reshapingValuationBlock ||
            action == this.actions.loadValuationBlock) {
            this.propertiesForm.setControl(ViewApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES, new FormControl(propArray));
            if (!this.propertiesForm.get(ViewApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value) {
                this.propertiesForm.setControl(ViewApplicationLocationPvConstants.SALES_AREA_PROPERTIES, new FormControl(propArray));
            }
        }
    }
    setProperties(sgCodeZoneLookup, selectedPropertyDetails, selectedOwnerDetails, action, sketchGraphic) {
        const propArray = [];
        // this.properties.clear();
        // let idVal = -1;
        if (selectedPropertyDetails.features.length > 0) {
            selectedPropertyDetails.features.forEach((feat) => {
                const attr = feat.attributes;
                const geom = feat.geometry;
                const sgCode = this.propertyDataAlternateColumnName(attr, "SgCode", "sgcode");
                const zoning = (sgCodeZoneLookup.has(sgCode) ? sgCodeZoneLookup.get(sgCode) : "");
                let selectedPropertyOwners = [];
                // if (selectedOwnerDetails)
                selectedPropertyOwners = this.getOwnersForProperties(selectedOwnerDetails, sgCode);
                try {
                    const prop = {
                        id: -attr.OBJECTID,
                        sgCode,
                        address: this.propertyDataAlternateColumnName(attr, "Address", "address"),
                        allotment: this.propertyDataAlternateColumnName(attr, "Allotment", "allotment"),
                        zoning: zoning,
                        erfSize: this.propertyDataAlternateColumnName(attr, "ErfSize", "erfsize"),
                        farmNumber: this.propertyDataAlternateColumnName(attr, "FarmNo", "farmno"),
                        erfNumber: this.propertyDataAlternateColumnName(attr, "ErfNo", "erfno"),
                        subdivision: this.propertyDataAlternateColumnName(attr, "PtnNum", "ptnnum"),
                        unitNumber: this.propertyDataAlternateColumnName(attr, "UnitNumber", "unitnumber"),
                        description: this.propertyDataAlternateColumnName(attr, "PropertyDescription", "propertydescription"),
                        owners: selectedPropertyOwners,
                        deleted: false,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(geom.toJSON()),
                        wkid: 102100,
                    };
                    const index = propArray.findIndex((x) => x.sgCode == prop.sgCode);
                    if (index == -1) {
                        if (
                        /*action == this.actions.loadSalesArea || */ action ==
                            this.actions.loadValuationBlock) {
                            const existingProp = this.pvApplication.properties.find((x) => x.sgCode == prop.sgCode);
                            propArray.push(existingProp);
                        }
                        else {
                            propArray.push(prop);
                        }
                    }
                    //   idVal--;
                }
                catch {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.appController.showMessage(CreateApplicationLocationPvConstants.INVALID_PROPERTY_ATTRIBUTE, AlertType.Error);
                }
            });
            this.setBlocksProperties(propArray, action, sketchGraphic);
            this.loadTable(propArray, action);
        }
        else {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.showMessage(ViewApplicationLocationPvConstants.NO_POLYGONS_FOUND, AlertType.Warning);
        }
        this.changeDetectorRefs.detectChanges();
    }
    loadTable(propArray, action) {
        if (action == this.actions.loadValuationBlock ||
            action == this.actions.reshapingValuationBlock) {
            this.propertiesForm.setControl("dataSource", new FormControl(new BehaviorSubject([])));
            const tableDataSource = this.propertiesForm.get("dataSource")
                .value;
            const tableItems = [];
            // if (tableDataSource1 && tableDataSource1.value)
            //   tableItems = [...tableDataSource1.value];
            propArray.forEach((property) => {
                if (property) {
                    property.publicFieldCardLink = getPropertyFieldCardLink(() => this.generateReport(property.id, ViewApplicationLocationPvConstants.FIELD_CARD_PUBLIC_REPORT));
                    property.municipalFieldCardLink = getPropertyFieldCardLink(() => this.generateReport(property.id, ViewApplicationLocationPvConstants.FIELD_CARD_MUNICIPAL_REPORT));
                    const index = tableItems.findIndex((x) => x.sgCode == property.sgCode);
                    if (index == -1)
                        tableItems.push(property);
                }
            });
            tableDataSource.next(tableItems);
        }
        try {
            this.syncMapGeometries(action);
            this.changeDetectorRefs.detectChanges();
            this.requestStatusService.removeBusySpinner("GetPropertyData");
        }
        catch (err) {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.showMessage(err, AlertType.Error);
        }
    }
    generateReport(propertyId, reportType) {
        this.reportService.getReportGroupByGroupAndReportName(+this.appController.selectedModuleID, reportType).subscribe(x => {
            let model;
            if (reportType == ViewApplicationLocationPvConstants.FIELD_CARD_PUBLIC_REPORT)
                model = setPublicFieldCardParameters(x, propertyId, +this.appController.selectedModuleID);
            else if (reportType == ViewApplicationLocationPvConstants.FIELD_CARD_MUNICIPAL_REPORT)
                model = setMunicipalFieldCardParameters(x, propertyId, +this.appController.selectedModuleID);
            this.reportService.generateReport(model).pipe(take(1)).subscribe({
                next: (response) => {
                    handleReportDownload(response, model);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationLocationPvConstants.name, error, CRUDOperation.Get);
                }
            });
        });
    }
    getOwnersForProperties(data, sgCode) {
        const ownerFeatures = data;
        const propertyOwners = [];
        ownerFeatures.features.forEach((item) => {
            const ownerSgCode = this.propertyDataAlternateColumnName(item.attributes, "SgCode", "sgcode");
            if (ownerSgCode === sgCode) {
                try {
                    const newOwner = {
                        name: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                        surname: this.propertyDataAlternateColumnName(item.attributes, "Surname", "surname"),
                        telephone: this.propertyDataAlternateColumnName(item.attributes, "Telephone", "telephone"),
                        email: this.propertyDataAlternateColumnName(item.attributes, "Email", "email"),
                        defaultCommunicationMethod: this.propertyDataAlternateColumnName(item.attributes, "DefaultCommunicationMethod", "defaultCommunicationMethod"),
                        postalAddress: this.propertyDataAlternateColumnName(item.attributes, "PostalAddress", "postalAddress"),
                        designation: this.propertyDataAlternateColumnName(item.attributes, "Designation", "designation"),
                        organisation: this.propertyDataAlternateColumnName(item.attributes, "Organisation", "organisation"),
                        streetAddress: this.propertyDataAlternateColumnName(item.attributes, "StreetAddress", "streetAddress"),
                        homePhone: this.propertyDataAlternateColumnName(item.attributes, "Homephone", "homephone"),
                        idNumber: this.propertyDataAlternateColumnName(item.attributes, "IDNumber", "iDNumber"),
                        organisationRegistrationNumber: this.propertyDataAlternateColumnName(item.attributes, "organisationRegistrationNumber", "OrganisationRegistrationNumber"),
                        representative: this.propertyDataAlternateColumnName(item.attributes, "Representative", "representative"),
                        fax: this.propertyDataAlternateColumnName(item.attributes, "Fax", "fax"),
                        cellphone: this.propertyDataAlternateColumnName(item.attributes, "Cellphone", "cellphone"),
                        streetSuburb: this.propertyDataAlternateColumnName(item.attributes, "StreetSuburb", "streetSuburb"),
                        streetCity: this.propertyDataAlternateColumnName(item.attributes, "StreetCity", "streetCity"),
                        streetProvince: this.propertyDataAlternateColumnName(item.attributes, "StreetProvince", "streetProvince"),
                        streetCode: this.propertyDataAlternateColumnName(item.attributes, "StreetCode", "streetCode"),
                        postalSuburb: this.propertyDataAlternateColumnName(item.attributes, "PostalSuburb", "postalSuburb"),
                        postalCity: this.propertyDataAlternateColumnName(item.attributes, "PostalCity", "postalCity"),
                        postalProvince: this.propertyDataAlternateColumnName(item.attributes, "PostalProvince", "postalProvince"),
                        postalCode: this.propertyDataAlternateColumnName(item.attributes, "PostalCode", "postalCode"),
                        postalCountry: this.propertyDataAlternateColumnName(item.attributes, "PostalCountry", "postalCountry"),
                        streetCountry: this.propertyDataAlternateColumnName(item.attributes, "StreetCountry", "streetCountry"),
                        professionalBody: this.propertyDataAlternateColumnName(item.attributes, "ProfessionalBody", "professionalBody"),
                        professionalBodyRegNum: this.propertyDataAlternateColumnName(item.attributes, "professionalBodyRegistrationNumber", "ProfessionalBodyRegistrationNumber"),
                        groups: this.ownerGroups,
                    };
                    propertyOwners.push(newOwner);
                }
                catch (err) {
                    this.appController.showMessage("Error building the owner", AlertType.Error);
                }
            }
        });
        return propertyOwners;
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal =
                    propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal =
                    propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null
                        ? value
                        : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal =
                    propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    removeExistingProperties(action) {
        if (this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value &&
            (action == this.actions.drawingSalesArea ||
                action == this.actions.loadSalesArea)) {
            this.propertiesForm
                .get("tableSelection")
                .setValue(this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value);
            this.removePropertiesAfterDraw();
            this.propertiesForm
                .get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES)
                .setValue(null);
            this.propertiesEdited = true;
        }
        if (this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).value &&
            (action == this.actions.reshapingValuationBlock ||
                action == this.actions.loadValuationBlock)) {
            this.propertiesForm
                .get("tableSelection")
                .setValue(this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).value);
            this.removePropertiesAfterDraw();
            this.propertiesForm
                .get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES)
                .setValue(null);
            this.propertiesEdited = true;
        }
    }
    removePropertiesAfterDraw() {
        const itemsForDeletion = this.propertiesForm.get("tableSelection").value;
        const tableSource = this.propertiesForm.get("dataSource")
            .value;
        if (itemsForDeletion.length === 0) {
            return;
        }
        // const deletedItem = itemsForDeletion;
        // let index = 0;
        const itemsAlreadyOnTable = tableSource.getValue();
        // for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
        //   if (itemsAlreadyOnTable[i] === deletedItem) {
        //     index = i;
        //   }
        // }
        for (let i = 0, len = itemsForDeletion.length; i < len; i++) {
            if (!itemsForDeletion[i])
                continue;
            const ItemIndex = itemsAlreadyOnTable.findIndex((b) => b.sgCode === itemsForDeletion[i].sgCode);
            itemsAlreadyOnTable.splice(ItemIndex, 1);
        }
        const allItems = [...itemsAlreadyOnTable];
        tableSource.next(allItems);
        this.propertiesForm.get("tableSelection").setValue([]);
        this.changeDetectorRefs.markForCheck();
        this.changeDetectorRefs.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationPropertyTableHeadingLookup;
    }
    setupPropertyForm(properties) {
        this.properties.clear();
        // let properties: IPvProperty[] = [];
        properties.forEach((prop) => {
            const newProperty = new FormGroup({
                // id: new FormControl(prop.id),
                sgCode: new FormControl(prop.sgCode, [Validators.required]),
                address: new FormControl(prop.address),
                allotment: new FormControl(prop.allotment),
                zoning: new FormControl(prop.zoning),
                erfSize: new FormControl(prop.erfSize),
                farmNumber: new FormControl(prop.farmNumber, [Validators.required]),
                erfNumber: new FormControl(prop.erfNumber, [Validators.required]),
                subdivision: new FormControl(prop.subdivision),
                unitNumber: new FormControl(prop.unitNumber?.toString()),
                description: new FormControl(prop.description),
                owners: new FormControl(prop.owners, [Validators.required]),
                deleted: new FormControl(prop.deleted),
                shape: new FormControl(prop.shape, [Validators.required]),
                wkid: new FormControl(prop.wkid, [Validators.required]),
            });
            if (prop.erfNumber && prop.erfNumber.trim()) {
                newProperty.get("farmNumber").clearValidators();
                newProperty.get("farmNumber").updateValueAndValidity();
            }
            if (prop.farmNumber && prop.farmNumber.trim()) {
                newProperty.get("erfNumber").clearValidators();
                newProperty.get("erfNumber").updateValueAndValidity();
            }
            this.properties.push(newProperty);
        });
    }
    setSalesAreaProperty() {
        const porperties = this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value;
        const salesAreaProperties = [];
        porperties.forEach((x) => {
            salesAreaProperties.push({
                id: 0,
                sgCode: x.sgCode,
                salesAreaId: this.pvApplication.salesAreaId,
                deleted: false,
            });
        });
        this.propertiesEdited = true;
        return salesAreaProperties;
    }
    onBtnSaveClicked($event) {
        if (this.propertiesEdited) {
            if (this.propertiesForm.valid) {
                const propertiesArray = this.propertiesForm.get("properties");
                const properties = [];
                propertiesArray.controls.forEach((item) => {
                    const owners = item.get("owners").value
                        ? item.get("owners").value
                        : [];
                    owners.forEach((owner) => {
                        owner = RecipientUtils.removeRecipientProperties(owner);
                        const group = {
                            groupName: "Owner",
                            groupType: "External",
                        };
                        owner.groups = [group];
                    });
                    const property = {
                        sgCode: item.get("sgCode").value,
                        address: item.get("address").value,
                        allotment: item.get("allotment").value,
                        zoning: item.get("zoning").value,
                        erfNumber: item.get("erfNumber").value,
                        farmNumber: item.get("farmNumber").value,
                        unitNumber: item.get("unitNumber").value,
                        subdivision: item.get("subdivision").value,
                        erfSize: Number(item.get("erfSize").value),
                        description: item.get("description").value,
                        deleted: item.get("deleted").value,
                        shape: item.get("shape").value,
                        wkid: item.get("wkid").value,
                        owners,
                    };
                    properties.push(property);
                });
                //ViewApplicationLocationPvConstants.SALES_AREA_SHAPE
                const shape = this.propertiesForm.get(ViewApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE).value;
                const request = {
                    properties: properties,
                    applicationShape: WktConverterUtils.ConvertArcGISJsonToWkt(shape),
                    applicationWkid: 102100,
                };
                this.propertyValuationService
                    .setValuationBlockPropertiesProperties(request, this.pvApplication.id)
                    .subscribe((resp) => {
                    //get valuations for properties
                    this.blockProperties.forEach((p) => {
                        this.viewBlockPropertiesPvService.get(p.id).subscribe((resp) => {
                            const pvValuations = resp;
                            if (pvValuations.length > 0) {
                                pvValuations.forEach((el) => {
                                    //reject all valuations
                                    this.stepService.rejectValuation(el.id).pipe(takeUntil(this._destroy$), take(1)).subscribe({
                                        next: () => {
                                            this.appController.showMessage(ViewApplicationLocationPvConstants.VALUATIONS_REJECTED, AlertType.Success);
                                        }, error: (error) => {
                                            this.appController.handleServerErrorMessage(ViewApplicationLocationPvConstants.VALUATION_STATUS_ERROR, error, CRUDOperation.Update);
                                        }
                                    });
                                });
                            }
                        });
                    });
                });
                /// SETUP SALE AREA hasSalesArea
                const salesAreaShape = this.propertiesForm.get("salesAreaShape").value;
                const salesArea = {
                    id: this.pvApplication.salesAreaId,
                    wkid: 102100,
                    shape: WktConverterUtils.ConvertArcGISJsonToWkt(salesAreaShape),
                    deleted: false,
                    SalesAreaProperties: this.setSalesAreaProperty(),
                };
                this.propertyValuationService
                    .setSalesArea(salesArea, this.pvApplication.salesAreaId)
                    .subscribe((res) => {
                });
                this.appController.showMessage(ViewApplicationLocationPvConstants.REDRAW_SUCCESS_NOTIFICATION, AlertType.Success);
            }
        }
        else {
            this.appController.showMessage(ViewApplicationLocationPvConstants.NO_EDITS, AlertType.Warning);
        }
    }
    showPropertyDetails() {
        const selectedProperty = this.propertiesForm.get("tableSelection")
            .value[0];
        this.propertyToEdit = true;
        this.propertyDetailsForm.get("editIndex").setValue(selectedProperty.id);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.SG_CODE_CONTROL_NAME)
            .setValue(selectedProperty.sgCode);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.AREA_CONTROL_NAME)
            .setValue(selectedProperty.allotment);
        if (selectedProperty.zoning) {
            this.propertyDetailsForm
                .get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME)
                .setValue(selectedProperty.zoning);
        }
        else {
            this.propertyDetailsForm
                .get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME)
                .setValue(null);
        }
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.PORTION_NUMBER_CONTROL_NAME)
            .setValue(selectedProperty.subdivision);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.ADDRESS_CONTROL_NAME)
            .setValue(selectedProperty.address);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.DESCRIPTION_CONTROL_NAME)
            .setValue(selectedProperty.description);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.ERF_NUMBER_CONTROL_NAME)
            .setValue(selectedProperty.erfNumber);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.FARM_NUMBER_CONTROL_NAME)
            .setValue(selectedProperty.farmNumber);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.UNIT_NUMBER_CONTROL_NAME)
            .setValue(selectedProperty.unitNumber);
        this.propertyDetailsForm
            .get(EditPropertyDetailsPvConstants.ERF_SIZE_CONTROL_NAME)
            .setValue(selectedProperty.erfSize);
        const ownerControl = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME);
        ownerControl.reset();
        this.changeDetectorRefs.detectChanges();
        if (selectedProperty.owners && selectedProperty.owners.length > 0) {
            this.recipientListService.setRecipients(selectedProperty.owners, true, ownerControl);
        }
    }
    getLookups() {
        const lookupParams = {
            $filter: `moduleId eq ${this.appController.selectedModuleID}  and (name eq 'PropertyType' or name eq 'Zoning')`
        };
        this.createLookupsSubscription = this.viewApplicationService
            .getLookupsObservable(lookupParams)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            },
        });
    }
    onGetLookupsCompleted(response) {
        const propertyTypes = [];
        const zones = [];
        if (response.value.length > 0) {
            response.value.forEach((item) => {
                if (item.name === "PropertyType") {
                    propertyTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("propertyTypes", propertyTypes);
        this.propertyTypesOptions = propertyTypes;
        this.aflaModuleStrategyService.lookups.set("Zoning", zones);
        this.zoningsFromLookups = zones;
        this.updateDefinitionExpression();
    }
    updateDefinitionExpression() {
        if (this.propertyType) {
            const categories = [];
            let searchNull = false;
            this.propertyTypesOptions.forEach(item => {
                if (item.code === this.propertyType) {
                    if (item.code.toLowerCase() === "no category information" || item.value.toLowerCase() === "no category information"
                        || item.value.toLowerCase() === "null" || item.value.toLowerCase() === "") {
                        searchNull = true;
                    }
                    else {
                        categories.push("'" + item.value + "'");
                    }
                }
            });
            this.categoriesFromLookups = categories;
            this.categoryFilterString = "";
            if (categories.length > 0) {
                this.categoryFilterString = "ZoningCategory in (" + categories.join("','") + ")";
            }
            if (searchNull) {
                if (this.categoryFilterString !== "") {
                    this.categoryFilterString += " or ";
                }
                this.categoryFilterString += `ZoningCategory is null`;
            }
            this.propertyLayer.definitionExpression = this.categoryFilterString;
        }
    }
    updateProperty($event) {
        this.updatePropertyDetailsValidation();
        this.propertyDetailsForm.markAllAsTouched();
        this.changeDetectorRefs.detectChanges();
        const tableDataSource = this.propertiesForm.get("dataSource").value;
        const itemsAlreadyOnTable = tableDataSource.getValue();
        const editIndex = this.propertyDetailsForm.get("editIndex").value;
        const idx = itemsAlreadyOnTable.findIndex((x) => x.id === editIndex);
        const owners = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].sgCode = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.SG_CODE_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].allotment = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.AREA_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].zoning = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].address = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ADDRESS_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].description = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.DESCRIPTION_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].erfNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].farmNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.FARM_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].subdivision = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.PORTION_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].unitNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.UNIT_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].erfSize = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_SIZE_CONTROL_NAME).value;
        if (owners && owners.hasOwnProperty("recipients")) {
            itemsAlreadyOnTable[idx].owners = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME).value["recipients"];
        }
        else {
            itemsAlreadyOnTable[idx].owners = [];
        }
        const allItems = [...itemsAlreadyOnTable];
        tableDataSource.next(allItems);
        this.changeDetectorRefs.markForCheck();
        this.changeDetectorRefs.detectChanges();
        // this.syncMapGeometries(false,false);
    }
    updatePropertyDetailsValidation() {
        this.propertyDetailsForm.clearValidators();
        const sgCodeControl = this.propertyDetailsForm.get("sgCodeEdit");
        const addressControl = this.propertyDetailsForm.get("addressEdit");
        const ownersControl = this.propertyDetailsForm.get("ownersEdit");
        const erfNoControl = this.propertyDetailsForm.get("erfNumberEdit");
        const farmNoControl = this.propertyDetailsForm.get("farmNumberEdit");
        const erfSizeControl = this.propertyDetailsForm.get("erfSizeEdit");
        const portionNumControl = this.propertyDetailsForm.get("portionNumberEdit");
        ownersControl.addValidators(Validators.required);
        addressControl.addValidators(Validators.required);
        sgCodeControl.addValidators(Validators.required);
        erfSizeControl.addValidators([Validators.required, Validators.min(0.1)]);
        if (erfNoControl.value !== undefined &&
            erfNoControl.value !== null &&
            erfNoControl.value.trim() !== "") {
            erfNoControl.addValidators(Validators.required);
            farmNoControl.clearValidators();
            farmNoControl.disable();
            farmNoControl.markAsUntouched();
        }
        else if (farmNoControl.value !== undefined &&
            farmNoControl.value !== null &&
            farmNoControl.value.trim() !== "") {
            erfNoControl.clearValidators();
            farmNoControl.addValidators(Validators.required);
            portionNumControl.addValidators(Validators.required);
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.addValidators(Validators.required);
            farmNoControl.addValidators(Validators.required);
            portionNumControl.addValidators(Validators.required);
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            erfNoControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        sgCodeControl.updateValueAndValidity();
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        ownersControl.updateValueAndValidity();
        erfNoControl.updateValueAndValidity();
        portionNumControl.updateValueAndValidity();
    }
    static ctorParameters = () => [
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: ViewApplicationService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: MapService },
        { type: StepService },
        { type: ViewBlockPropertiesPvService },
        { type: MapTools },
        { type: RequestStatusService },
        { type: PropertyValuationService },
        { type: ChangeDetectorRef },
        { type: ViewApplicationLocationService },
        { type: ReportService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: false },] }]
    };
};
ViewApplicationLocationPvComponent = __decorate([
    Component({
        selector: "app-view-application-location-pv",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationPvComponent);
export { ViewApplicationLocationPvComponent };
